import { SxProps, Tab, Tabs } from '@mui/material';
import { indigo } from '@mui/material/colors';

export interface TabContainerProps {
  tabLabels: string[];
  setTab: (nextTab: number) => void;
  currentTab: number;
  disabledTabs?: number[];
  sx?: {
    backGroundStyles?: SxProps;
    tabStyles?: SxProps;
  };
}

export const TabContainer = ({
  tabLabels,
  setTab,
  currentTab,
  disabledTabs = [],
  sx,
}: TabContainerProps) => {
  const setBackgroundColor = (index: number) => {
    if (disabledTabs.includes(index)) {
      return 'rgba(0, 0, 0, 0.26)'; // disabled
    }
    if (currentTab === index) {
      return '#FFFFFF';
    }

    return '#3F51B5';
  };

  const setColor = (index: number) => {
    if (currentTab === index) {
      return '#2C303B';
    }

    return '#A0B1DF';
  };

  return (
    <Tabs
      data-testid="tab-container"
      value={currentTab}
      onChange={(_, value) =>
        disabledTabs.includes(value) ? setTab(currentTab) : setTab(value)
      }
      aria-label="tabs"
      sx={{
        backgroundColor: indigo[700],
        borderBottom: 0,
        position: 'sticky',
        zIndex: 100,
        top: 0,
        '& .MuiTabs-indicator': {
          backgroundColor: 'transparent !important',
        },
        '& .MuiTabs-flexContainer': {
          paddingLeft: '24px !important',
        },
        ...sx?.backGroundStyles,
      }}
    >
      {tabLabels?.map((label: string, index: number) => {
        return (
          <Tab
            data-testid="tab"
            key={`${label}.${index}`}
            sx={{
              backgroundColor: setBackgroundColor(index),
              borderRadius: '4px 4px 0px 0px',
              ...sx?.tabStyles,
            }}
            label={
              <span
                style={{
                  color: setColor(index),
                  fontSize: '12px',
                  fontWeight: '700',
                }}
              >
                {label}
              </span>
            }
          />
        );
      })}
    </Tabs>
  );
};
